enum Section {
  AboutThePrice = 'AboutThePrice',
  Ancillaries = 'Ancillaries',
  Breadcrumbs = 'Breadcrumbs',
  Brochures = 'Brochures',
  BuyWithConfidence = 'BuyWithConfidence',
  ComposerAvailabilityNotice = 'ComposerAvailabilityNotice',
  Condition = 'Condition',
  CosmeticCondition = 'CosmeticCondition',
  Disclaimer = 'Disclaimer',
  Features = 'Features',
  FeaturesAndHighlights = 'FeaturesAndHighlights',
  FeaturesAndSpecs = 'FeaturesAndSpecs',
  Gallery = 'Gallery',
  General = 'General',
  GoodToKnow = 'GoodToKnow',
  Hero = 'Hero',
  Highlights = 'Highlights',
  Inspection = 'Inspection',
  InspectionAndGuarantee = 'InspectionAndGuarantee',
  InspectionInProgressCard = 'InspectionInProgressCard',
  MoneyBackGuarantee = 'MoneyBackGuarantee',
  NeedItSooner = 'NeedItSooner',
  NewCarBanner = 'NewCarBanner',
  OwnerReviews = 'OwnerReviews',
  PickupAndDelivery = 'PickupAndDelivery',
  PriceDetails = 'PriceDetails',
  RecallStatus = 'RecallStatus',
  RecommendedVehicles = 'RecommendedVehicles',
  Root = 'Root',
  SafetyAndMechanical = 'SafetyAndMechanical',
  SebastianQuestions = 'SebastianQuestions',
  Spinner = 'Spinner',
  VehicleDetails = 'VehicleDetails',
  VehicleInfo = 'VehicleInfo',
  Warranty = 'Warranty',
  WarrantyStatus = 'WarrantyStatus',
  WhyBuy = 'WhyBuy'
}

export const SectionId = {
  [Section.AboutThePrice]: 'about-the-price',
  [Section.Ancillaries]: 'ancillaries',
  [Section.Breadcrumbs]: 'breadcrumbs',
  [Section.Brochures]: 'brochures',
  [Section.BuyWithConfidence]: 'buy-with-confidence',
  [Section.ComposerAvailabilityNotice]: 'composer-availability-notice',
  [Section.Condition]: 'condition',
  [Section.CosmeticCondition]: 'cosmetic-condition',
  [Section.Disclaimer]: 'disclaimer',
  [Section.Features]: 'features',
  [Section.FeaturesAndHighlights]: 'features-and-highlights',
  [Section.FeaturesAndSpecs]: 'features-and-specs',
  [Section.Gallery]: 'gallery',
  [Section.General]: 'navigation-section',
  [Section.GoodToKnow]: 'good-to-know',
  [Section.Hero]: 'hero',
  [Section.Highlights]: 'highlights',
  [Section.Inspection]: 'inspection',
  [Section.InspectionAndGuarantee]: 'inspection-and-guarantee',
  [Section.InspectionInProgressCard]: 'inspection-in-progress-card',
  [Section.MoneyBackGuarantee]: 'money-back-guarantee',
  [Section.NeedItSooner]: 'need-it-sooner',
  [Section.NewCarBanner]: 'new-car-banner',
  [Section.OwnerReviews]: 'owner-reviews',
  [Section.PickupAndDelivery]: 'pickup-and-delivery',
  [Section.PriceDetails]: 'price-details',
  [Section.RecallStatus]: 'recall-status',
  [Section.RecommendedVehicles]: 'recommended-vehicles',
  [Section.Root]: 'root',
  [Section.SafetyAndMechanical]: 'safety-and-mechanical',
  [Section.SebastianQuestions]: 'sebastian-questions',
  [Section.Spinner]: 'spinner-container',
  [Section.VehicleDetails]: 'vehicle-details',
  [Section.VehicleInfo]: 'vehicle-info',
  [Section.Warranty]: 'warranty',
  [Section.WarrantyStatus]: 'warranty-status',
  [Section.WhyBuy]: 'why-buy'
} as const satisfies Record<Section, string>;

export type TSectionId = (typeof SectionId)[keyof typeof SectionId];

export const SectionName = {
  [Section.AboutThePrice]: 'About The Price',
  [Section.Ancillaries]: 'Ancillaries',
  [Section.Breadcrumbs]: 'Breadcrumbs',
  [Section.Brochures]: 'Brochures',
  [Section.BuyWithConfidence]: 'Buy With Confidence',
  [Section.ComposerAvailabilityNotice]: 'Composer Availability Notice',
  [Section.Condition]: 'Condition',
  [Section.CosmeticCondition]: 'Cosmetic Condition',
  [Section.Disclaimer]: 'Disclaimer',
  [Section.Features]: 'Features',
  [Section.FeaturesAndHighlights]: 'Features and Highlights',
  [Section.FeaturesAndSpecs]: 'Features and Specs',
  [Section.Gallery]: 'Gallery',
  [Section.General]: 'Navigation Section',
  [Section.GoodToKnow]: 'Good to Know',
  [Section.Hero]: 'Hero',
  [Section.Highlights]: 'Highlights',
  [Section.Inspection]: 'Inspection',
  [Section.InspectionAndGuarantee]: 'Inspection and Guarantee',
  [Section.InspectionInProgressCard]: 'Inspection in Progress Card',
  [Section.MoneyBackGuarantee]: 'Money Back Guarantee',
  [Section.NeedItSooner]: 'Need It Sooner',
  [Section.NewCarBanner]: 'New Car Banner',
  [Section.OwnerReviews]: 'Owner Reviews',
  [Section.PickupAndDelivery]: 'Pickup and Delivery',
  [Section.PriceDetails]: 'Price Details',
  [Section.RecallStatus]: 'Recall Status',
  [Section.RecommendedVehicles]: 'Recommended Vehicles',
  [Section.Root]: 'Root',
  [Section.SafetyAndMechanical]: 'Safety and Mechanical',
  [Section.SebastianQuestions]: 'Sebastian Questions',
  [Section.Spinner]: 'Spinner Container',
  [Section.VehicleDetails]: 'Vehicle Details',
  [Section.VehicleInfo]: 'Vehicle Info',
  [Section.Warranty]: 'Warranty',
  [Section.WarrantyStatus]: 'Warranty Status',
  [Section.WhyBuy]: 'Why Buy'
} as const satisfies Record<Section, string>;

export default Section;
